import Vue from 'vue'
import Router from 'vue-router'
import { isProd } from '@/utils'
import store from './store'
import Home from './views/Home'
import Shop from './views/Shop'
import Account from './views/Account'
import Login from './views/Login'
import ForgetPassword from './views/ForgetPassword'
import ResetPassword from './views/ResetPassword'
import ExercisePage from './views/ExercisePage'
import Progress from './views/Progress'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true, control: 'home' },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Login,
      props: { register: true },
    },
    {
      path: '/forget-password',
      name: 'forget-password',
      component: ForgetPassword,
    },
    {
      path: '/reset-password/:userId/:resetToken',
      name: 'reset-password',
      component: ResetPassword,
      props: true,
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop,
      meta: { control: 'home' },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: { control: 'home' },
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('./views/History'),
      meta: { control: 'home' },
    },
    {
      path: '/progress',
      name: 'progress',
      component: Progress,
      meta: { control: 'home' },
    },
    {
      path: '/admin',
      component: () => import('./views/Admin'),
      meta: { control: 'home' },
      children: [
        {
          path: '',
          name: 'admin',
          component: () => import('./views/Admin/UserList'),
          meta: { control: 'home' },
        },
      ],
    },
    {
      path: '/:exercise([a-z-]+)',
      name: 'exercise',
      component: ExercisePage,
      props: true,
      meta: { control: 'home' },
    },
  ]
})

export default router

router.beforeEach((to, from, next) => {
  const { requiresAuth } = to.meta
  const isAuthed = store.getters['auth/authed']
  if (requiresAuth && !isAuthed) {
    next('/login')
  } else {
    next()
  }

  const isAdmin = store.getters['auth/isAdmin']
  if (to.meta.role == 'admin' && !isAdmin) {
    next('/')
  }
})
